import React from 'react';

import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';

import { getUserSettings, setUserSettings, getSystemSettings, getCurrencyDatabase } from '../../utils/SettingsRetriever';
import CurrencyDatabase from '../../utils/CurrencyDatabase';
import QueryStringRetriever from '../../utils/QueryStringRetriever';

import Dialog from '../Dialog';
import SpotlioIcon from '../Icon';
import IntlMessage from '../../LocaleEngine';

import './index.scss';
export default class CurrencySelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCurrency: getUserSettings() && getUserSettings().currencies && getUserSettings().currencies.selected,
            currenciesList: getSystemSettings().app.currency,
            disclaimer: false,
            displayModal: false
        };

        if(getSystemSettings().app.currency && getSystemSettings().app.currency.disclaimer) {
            this.state.disclaimer = getSystemSettings().app.currency.disclaimer;
        }
    }

    componentDidMount(){
        let { currency } = QueryStringRetriever();
        if (currency && this.state.currenciesList && this.state.currenciesList.list ){
            let currencyInArray = this.state.currenciesList.list.find(curr => curr.base === currency);
            if (currencyInArray){
                let index = this.state.currenciesList.list.indexOf(currencyInArray);
                this.setState({ selectedCurrency: index }, () => {
                    const UserSettings = getUserSettings();
                    setUserSettings({
                        ...UserSettings,
                        currencies: {
                            ...UserSettings.currencies,
                            selected: this.state.selectedCurrency
                        }
                    });
                })
            }
        }
    }

    handleUpdateSystemSettings = () => {
        const UserSettings = getUserSettings();
        setUserSettings({
            ...UserSettings,
            currencies: {
                ...UserSettings.currencies,
                selected: this.state.selectedCurrency
            }
        });
        this.setState({...this.state}, () => {
            const currencyDB = getCurrencyDatabase();
            console.log(currencyDB);
            const event = new CustomEvent("changeCurrency");
            if (currencyDB === false) {
                CurrencyDatabase(getSystemSettings()).then(() => {
                    document.dispatchEvent(event);
                })
            } else {
                document.dispatchEvent(event);
            }
        });
    }

    handleToggleCurrencyModal = () => {
        const modalState = !this.state.displayModal;
        this.setState({...this.state, displayModal: modalState});
    }

    handleSelectCurrency = (index) => {
        if (this.state.currenciesList.redirectCurrency){
            let currency = this.state.currenciesList.list[index];
            this.state.currenciesList.redirectCurrency.forEach(curr => {
                if (curr.name === currency.name){
                    window.location.href = curr.url;
                }
            })
        }
        this.setState({...this.state, selectedCurrency: index, displayModal: false}, () => this.handleUpdateSystemSettings());
    }

    handleRenderCurrenciesList = () => {
        const currentlySelectedCurrencyIndex = this.state.selectedCurrency;
        let favoriteCurrencies = [];
        let currenciesList = [];
        this.state.currenciesList.list.forEach((val, idx) => {
            if (idx === currentlySelectedCurrencyIndex) val.selected = true;
            else val.selected = false;
            val.idx = idx;
            if (this.state.currenciesList.preferred && this.state.currenciesList.preferred.indexOf(val.base) >= 0) {
                favoriteCurrencies.push(val);
            } else {
                currenciesList.push(val);
            }
        });
        
        const currencyComponent = (val, idx) => (
            <div key={idx} className={"CurrencyItem " + (val.selected ? "Selected" : "")} onClick={() => this.handleSelectCurrency(val.idx)}>
                <span className="CurrencyBase">{val.base}</span>{val.name}
            </div>
        )
        
        return (
            <React.Fragment>
                {
                    this.state.disclaimer ? <IntlMessage id={`${this.state.disclaimer}`} /> : null
                }
                {this.state.currenciesList.default !== this.state.selectedCurrency && (
                    <React.Fragment>
                        <div className="CurrenciesDialogTitle">
                            <IntlMessage id="currency.modal.currently_selected" />
                        </div>
                        <div key={'defaultCurrency'} className="CurrencyItem Selected" onClick={() => this.handleSelectCurrency(this.state.currenciesList.default)}>
                            <span className="CurrencyBase">{this.state.currenciesList.list[this.state.selectedCurrency].base}</span><IntlMessage id="header.currency.deactivate" />
                        </div>
                    </React.Fragment>
                )}
                {this.state.currenciesList.preferred && (
                    <React.Fragment>
                        <div className="CurrenciesDialogTitle">
                            <IntlMessage id="header.currency.top_currencies" />
                        </div>
                        {favoriteCurrencies.map((val, idx) => currencyComponent(val, idx) )}
                    </React.Fragment>
                )}
                <div className="CurrenciesDialogTitle">
                    <IntlMessage id="header.currency.all_currencies" />
                </div>
                {currenciesList.map((val, idx) => currencyComponent(val, idx) )}
            </React.Fragment>
        )
    }

    render() {
        if(this.state.currenciesList.list.length === 1) return '';

        let CurrencyLink = '';
        if (this.props.mode === "b2b") {
            CurrencyLink = <Avatar className={(this.props.className || '') + " CurrencySelectorButton Avatar"} onClick={() => this.handleToggleCurrencyModal()}>{this.state.currenciesList.list[this.state.selectedCurrency].base}</Avatar>
        } else {
            CurrencyLink =  (<Button onClick={() => this.handleToggleCurrencyModal()} className={(this.props.className || '') + " CurrencySelectorButton Link"} >
                                <SpotlioIcon icon="fa-money" />
                                <span><IntlMessage id="currency.buttons.currency" /></span>
                            </Button>)
        }

        return (
            <React.Fragment>
                { CurrencyLink }
                <Dialog
                    open={this.state.displayModal}
                    title={<IntlMessage id="header.currency.title" />}
                    className="CurrenciesModal"
                    closeFn={() => this.handleToggleCurrencyModal()}
                    container={() => document.getElementsByClassName('main-application')[0]}
                    footerContent={
                        <React.Fragment>
                            <Button onClick={() => this.handleToggleCurrencyModal()} className="secondary">
                                <IntlMessage id="profile.itinerary.modal.close" />
                            </Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        { this.handleRenderCurrenciesList() }
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }
}
